/* eslint-disable */
import { toastActionTypes } from "./actionTypes";

export const setToast = (payload) => {
  return {
    type: toastActionTypes.SET_ALERT_STATUS,
    payload,
  };
};
